export const customElement = (elementName: string) => {
    console.log(`Custom element defined.`);

    return function (constructor: CustomElementConstructor) {
        console.log(`Name of new element is ${constructor.name}`);
        if (!customElements.get(elementName)) {
            customElements.define(elementName, constructor);
        }
    };
};